// Copyright (c) 2023 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.

'use strict';

export const token = {
    tokenIconSubmitApi: 'https://api.etokens.cash/new',
    tokenIconsUrl: 'https://icons.etokens.cash',
    tokenDbUrl: 'https://tokendb.kingbch.com',
    newTokenDefaultUrl: 'cashtab.com',
    rewardsServerBaseUrl: 'https://rewards.etokens.cash',
};
